import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userActions } from 'onboarding/user.actions';
import { navigateToSite } from '../utils/orgSiteNavigate';
import OrgSiteName from './OrgSiteName';
import { SiteName, SiteRow } from './OrgWidgetLayout';

function OrgSiteRow({
  accountId, name, tooltip, compact, to, children, selectAccount
}) {
  const navigable = accountId != null;
  const go = () => navigateToSite(selectAccount, accountId, to);

  // Name first so a truncated one stays readable when the widget also supplies
  // a breakdown tooltip.
  const rowTitle = tooltip ? `${name} · ${tooltip}` : name;

  return (
    <SiteRow
      compact={compact}
      title={rowTitle}
      interactive={navigable}
      onClick={navigable ? go : undefined}
    >
      <SiteName compact={compact}>
        <OrgSiteName name={name} navigable={navigable} label={rowTitle} />
      </SiteName>
      {children}
    </SiteRow>
  );
}

OrgSiteRow.propTypes = {
  accountId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  tooltip: PropTypes.string,
  compact: PropTypes.bool,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  children: PropTypes.node,
  selectAccount: PropTypes.func.isRequired
};

OrgSiteRow.defaultProps = {
  accountId: null,
  name: '',
  tooltip: undefined,
  compact: false,
  to: null,
  children: null
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      selectAccount: userActions.selectAccount
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(OrgSiteRow);
